import * as actions from './search-actions';
import * as mutations from './search-mutations';
import { state } from './search-state';

export const search = {
  state,
  mutations,
  actions,
};
